import type { NoticeGridRegion, NoticeLayer } from './types.js';
export function validNoticeGridRegion(value: unknown): value is NoticeGridRegion {
  if (!value || typeof value !== 'object') return false;
  const v = value as NoticeGridRegion;
  return typeof v.preset === 'string' && v.preset.length <= 80 && Number.isInteger(v.index) && v.index >= 0 && v.index < 64
    && (v.role === 'media' || v.role === 'overlay') && [v.x, v.y, v.width, v.height].every(Number.isFinite)
    && v.x >= 0 && v.y >= 0 && v.width > 0 && v.height > 0 && v.x + v.width <= 1.000001 && v.y + v.height <= 1.000001;
}
export function noticeGridClip(layer: Pick<NoticeLayer, 'gridCell'>, width: number, height: number) {
  const r = layer.gridCell;
  if (!validNoticeGridRegion(r)) return null;
  const x = Math.round(r.x * width), y = Math.round(r.y * height);
  return { x, y, width: Math.round((r.x + r.width) * width) - x, height: Math.round((r.y + r.height) * height) - y };
}
